import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { StudentEligibilitiesService } from '../../../service/student-eligibilities.service';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import { EligibilityStatuses } from '../../../model/eligibility-statuses.model';
import { StudentEligibilities } from '../../../model/student-eligibilities.model';
import { EligibilityChangeReasonTypes } from '../../../model/eligibility-change-reason-types.model';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
    selector: 'view-child-eligibility-status',
    templateUrl: './view-child-eligibility-status.component.html',
    styleUrls: ['./view-child-eligibility-status.component.scss']
})
export class ViewChildEligibilityStatusComponent implements OnInit {
    @Input() studentId!: number;

    eligibilityChangeReasonTypes: EligibilityChangeReasonTypes[] = [];
    eligibilityStatuses: EligibilityStatuses[] = [];
    studentEligibilities: StudentEligibilities[];

    isLoading: boolean = false;
    promises: Array<any> = [];

    getPropertyPipe = new GetPropertyPipe();
    cleanDatePipe = new CleanDatePipe();
    simpleDatePipe = new SimpleDatePipe();

    // Table display
    studentEligibilityDisplayedColumns: string[] = [
        'CO.REGION.CODE',
        'CO.COE_NUMBER',
        'CO.SIGN_DATE',
        'CO.QUALIFYING_ARRIVAL_DATE',
        'CO.COE_MOVES[0].RESIDENCY_DATE',
        'ELIGIBILITY_END_DATE',
        'STUDENT_ELIGIBILITY_STATUS[0].ELIGIBILITY_STATUS.STATUS'
    ];

    // Table results
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    regions: any[] = [];
    studentEligibilityTableDataSource: MatTableDataSource<StudentEligibilities>;

    constructor(
        private studentEligibilitiesService: StudentEligibilitiesService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.init();
    }

    init() {
        this.isLoading = true;

        this.indexEligibilityChangeReasonTypes();
        this.indexEligibilityStatuses();
        this.getStudentEligibilities();

        Promise.all(this.promises).then((res) => {
            this.updateDataSource();

            this.isLoading = false;
        });
    }

    indexEligibilityChangeReasonTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.indexEligibilityChangeReasonTypes().subscribe((res) => {
                if (res.eligibilityChangeReasonTypes) {
                    this.eligibilityChangeReasonTypes = res.eligibilityChangeReasonTypes;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    indexEligibilityStatuses() {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.indexEligibilityStatuses().subscribe((res) => {
                if (res.eligiblityStatuses) {
                    this.eligibilityStatuses = res.eligiblityStatuses;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    getStudentEligibilities() {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getStudentEligibilities(this.studentId).subscribe((res) => {
                if (res.studentEligibilities) {
                    this.studentEligibilities = res.studentEligibilities;

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.studentEligibilityTableDataSource = new MatTableDataSource<StudentEligibilities>();
            this.studentEligibilityTableDataSource.data = this.studentEligibilities;

            // Paginator
            //this.studentEligibilityTableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.studentEligibilityTableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'CO.SIGN_DATE', direction: 'desc' };
            this.studentEligibilityTableDataSource.sort.active = defaultSort.active;
            this.studentEligibilityTableDataSource.sort.direction = defaultSort.direction;
            this.studentEligibilityTableDataSource.sort.sortChange.emit(defaultSort);
            this.studentEligibilityTableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.studentEligibilityTableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            setTimeout(() => {
                this.studentEligibilityTableDataSource.sort?.sortChange.emit(defaultSort);
            });
        });
    }
}
